/**
 * 用户端  草稿箱
 */
 <template>
    <div class="login-page">
      <topInfo></topInfo>
      <cusNav></cusNav>
      <!-- 主体内容 -->
      <div class="eval-content" style="margin-bottom: 40px;">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>案件列表</div>
            <div style="display: flex;justify-content: flex-end;margin-left: auto;">
               <div class="areaPicker">
                     <span style="color: #606266;font-size: 14px;">时间：</span>
                     <el-date-picker
                           v-model="caseDate"
                           type="daterange"
                           range-separator="-"
                           start-placeholder="开始时间"
                           end-placeholder="结束时间"
                           format="yyyy.MM.dd"
                           value-format="yyyy-MM-dd"
                           :picker-options="pickerOptions">
                     </el-date-picker>
                     <span class="clearBtn" style="margin-left: 4px;" title="清除时间" @click="clearDate()">清除</span>
                  </div>
               <div class="eval-con-search">
                  <el-input v-model="formInline.search" clearable placeholder="请输入关键词">
                     <el-button slot="append" style="color: #ffffff;" @click="search()">搜索</el-button>
                  </el-input>
               </div>
               <div class="eval-con-btn" @click="delCheckDrafts()">批量删除</div>
            </div>
         </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="recordData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" ref="multipleTable" @selection-change="handleSelectionChange">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="title" align="center" label="专利名称" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="type" align="center" label="专利类型" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="area" align="center" label="专利领域" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="add_time" align="center" label="时间" show-overflow-tooltip>
               </el-table-column>
               <el-table-column align="center" label="操作" min-width="80">
                  <template slot-scope="scope">
                     <el-button size="mini" type="primary" style="background-color: #2A91DD;" @click="editDrafts(scope.index, scope.row)">修改</el-button>
                     <el-button size="mini" type="danger" @click="delDrafts(scope.index, scope.row)">删除</el-button>
                  </template>
               </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
         </div>
      </div>
    </div>
 </template>
 <script>
   import { 
      getPageCaseDrafts,
      delCaseDrafts,
      delCheckCaseDrafts
   } from '../../api/evalMG'
   import Pagination from '../../components/Pagination'
   import topInfo from '../../components/topInfo'
   import cusNav from '../../components/cusNav'
   import { checkLogin } from '../../utils/util'
   export default {
      data() {
         return {
            loading: false,
            recordData: [],
            caseDate: [],
            formInline: {
               page: 1,
               ps: 10,
               search: '',
               startDate: '',
               endDate: ''
            },
            pickerOptions: {
               shortcuts: [{
               text: '最近一周',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
               picker.$emit('pick', [start, end]);
               }
            }, {
               text: '最近一个月',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
               picker.$emit('pick', [start, end]);
               }
            }, {
               text: '最近三个月',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
               picker.$emit('pick', [start, end]);
               }
            }]
            },
            multipleSelection: [], //列表勾选框值
            // 分页参数
            pageparm: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            }
         }
      },
      // 注册组件
      components: {
         Pagination,
         topInfo,
         cusNav
      },
      created(){
         this.getDraftsData()
      },
      methods: {
         checkType(val){
            this.applyForm.type = val
         },
         checkArea(val){
            this.applyForm.area = val
         },
         // 查询草稿箱列表
         getDraftsData(){
            this.loading = true
            let caseDate = this.caseDate
            if(caseDate&&caseDate.length>0){
               this.formInline.startDate = caseDate[0]
               this.formInline.endDate = caseDate[1]
            }else{
               this.formInline.startDate = ''
               this.formInline.endDate = ''
            }
            getPageCaseDrafts(this.formInline)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                  this.recordData = res.data.dataList
                  this.pageparm.currentPage = this.formInline.page
                  this.pageparm.pageSize = this.formInline.ps
                  this.pageparm.total = res.data.total
                  this.loading = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  }) 
               }
            })
         },
         // 编辑案件草稿
         editDrafts(index,row){
            // 跳转申请评估页面,并传递案件草稿id
            let drafts_id = row.id
            this.$router.push({ path: '/customer/applyEval',query: {drafts_id:drafts_id }});
         },
         // 删除案件草稿
         delDrafts(index,row){
            this.$confirm('确定删除草稿?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               let param = {
                  id: row.id
               }
            delCaseDrafts(param)
            .then(res=>{
                  if(res.code == 200){
                     this.$message({
                        type: 'success',
                        message: res.msg
                     }) 
                     this.getDraftsData()
                  }else{
                     this.$message({
                        type: 'error',
                        message: res.msg
                     }) 
                  }
               })
            })
            .catch(() => {
                  this.$message({
                     type: 'info',
                     message: '已取消'
                  })
               })
         },
         handleSelectionChange(val){
            this.multipleSelection = val;
         },
         // 删除案件草稿(勾选)
         delCheckDrafts(){
            let checkIds = this.multipleSelection
               if(checkIds.length <= 0){
                  this.$message({
                     type: 'warning',
                     message: '暂无勾选的数据!'
                  })
                  return false
            }
            this.$confirm('确定删除勾选中的草稿吗?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               let ids = []
               checkIds.forEach((item,index)=>{
                  ids.push(item.id)
               })
               let param = JSON.stringify(ids)
               delCheckCaseDrafts({ids: param})
                  .then(res=>{
                     if(res.code == 200){
                        this.$message({
                           type: 'success',
                           message: res.msg
                        })
                        this.getDraftsData()
                     }else{
                        this.$message({
                           type: 'error',
                           message: res.msg
                        })
                     }
                  })
               })
               .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
               })
         },
         // 点击搜索
         search(){
            this.getDraftsData()
         },
         // 清除时间
         clearDate(){
            this.caseDate = []
         },
         // 分页插件事件
         callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.ps = parm.pageSize
            this.getDraftsData()
         },
      }
   }
</script>
<style scoped>
  .login-page {
    text-align: center;
    /* height: 100%; */
  }
  .eval-content {
   width: 1200px;
   /* height: 600px; */
   margin: 0px auto;
   background-color: #fff;
   border-radius: 10px;
  }
  .eval-con-top {
   display: flex;
   margin: 10px 40px;
   padding: 16px 0px;
   /* border-bottom: 2px solid #eeeeee; */
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .eval-con-btn {
   width: 120px;
   height: 38px;
   line-height: 38px;
   text-align: center;
   color: #fff;
   background-color: #FF7070;
   border-radius: 5px;
   margin-left: 20px;
   cursor: pointer;
  }
  .eval-con-search>>>.el-input-group {
   border-radius: 10px !important;
  }
  .eval-con-search>>>.el-input-group__append, .el-input-group__prepend {
   color: #FFFFFF;
   background-color: #2A91DD;
   cursor: pointer;
  }
  .eval-con-search>>>.el-input__inner {
   background-color: #F3F3F3 !important;
   border: none;
  }
  .eval-table {
   width: 1120px;
   margin: 0px auto;
  }
  .eval-table>>> .el-table__header th {
   background-color: #2A91DD !important;
  }
  .eval-table>>> .el-table thead {
   color: #FFFFFF;
  }
  .areaPicker {
   margin-top: 2px;
   margin-right: 20px;
 }
 .areaPicker>>>.el-input__inner {
    width: 210px !important;
    height: 40px !important;
    line-height: 40px !important;
    margin-top: -4px !important;
    padding-top: 3px !important;
    padding-bottom: 3px !important;
    padding-left: 20px !important;
    padding-right: 0px !important;
}
.areaPicker>>>i {
    display: none !important;
}
.areaPicker>>>.el-date-editor .el-range-separator {
    line-height: 30px !important;
    color: #999999 !important;
}
.clearBtn {
   padding: 12px 10px;
   border: 1px solid #2A91DD;
   border-radius: 4px;
   color: #ffffff;
   background-color: #2A91DD;
   font-size: 12px;
   cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/customer/applyDrafts.vue